// filepath: apps/web/src/features/admin/audit/types.ts
//
// FR-UI-ADM-14 -- wire types for the Definition Audit Log Viewer.
// Mirrors the Go wire types in internal/audit/repository.go.
//
// INV-9: server-supplied strings rendered as text nodes only.
// INV-1: cache key includes tenantSlug.

export type DefinitionType =
  "form" | "process" | "entity" | "permission" | "task_spec";

export const DEFINITION_TYPES: readonly DefinitionType[] = [
  "form",
  "process",
  "entity",
  "permission",
  "task_spec",
] as const;

export type DefinitionTypeFilter = DefinitionType | "all";

export interface AuditEntry {
  id: string;
  tenant_id: string;
  definition_type: DefinitionType;
  definition_id: string;
  action: string;
  author_identity: string;
  agent_principal: string | null;
  task_spec_id: string | null;
  orchestrator_principal: string | null;
  version_before: number | null;
  version_after: number | null;
  created_at: string;
}

export interface Pagination {
  cursor: string;
  has_more: boolean;
}

export interface AuditListResponse {
  entries: AuditEntry[];
  pagination: Pagination;
}

export type AuditFetchState =
  | "loading"
  | "success"
  | "fetch-failure"
  | "permission-denied"
  | "validation-error"
  | "rate-limit";

export interface AuditFilterState {
  definition_type: DefinitionTypeFilter;
  author: string;
  after: string | null;
  before: string | null;
  cursor: string | null;
}

export interface AuditBackendError {
  kind:
    "fetch-failure" | "permission-denied" | "validation-error" | "rate-limit";
  message: string;
  retriable: boolean;
  retryAfterSeconds?: number;
}

export function emptyFilter(): AuditFilterState {
  return {
    definition_type: "all",
    author: "",
    after: null,
    before: null,
    cursor: null,
  };
}
